module.exports = __webpack_public_path__ + "img/cm_s5-desc.7dc56053.png";